import { ProjectData } from '@/types/project';

export function calculateMetrics(data: ProjectData) {
  // Ensure data exists
  if (!data?.value || !data?.costs) {
    return {
      totalRevenue: 0,
      totalCosts: 0,
      profit: 0,
      margin: 0,
    };
  }

  const totalRevenue = (data.value.contractValue || 0) + 
    (data.value.approvedVariations || 0) + 
    (data.value.unapprovedVariations || 0);

  const costComponents = ['labour', 'materials', 'plant', 'subcontractor', 'overheads', 'staff'] as const;
  const totalCosts = costComponents.reduce((sum, key) => 
    sum + (data.costs[key]?.toDate || 0) + (data.costs[key]?.forecast || 0), 0
  );

  const profit = totalRevenue - totalCosts;
  const margin = totalRevenue !== 0 ? (profit / totalRevenue) * 100 : 0;

  return {
    totalRevenue,
    totalCosts,
    profit,
    margin,
  };
}